import React, { useState } from 'react';
import { QUIZ, recommend } from '../../lib/providers';

export default function Quiz() {
  const [answers, setAnswers] = useState({});
  const [step, setStep] = useState(0);
  const done = step >= QUIZ.length;
  const reco = done ? recommend(answers) : null;

  const pick = (key, value) => {
    setAnswers((a) => ({ ...a, [key]: value }));
    setStep((s) => s + 1); // auto-advance: one tap per question
  };
  const reset = () => { setAnswers({}); setStep(0); };
  const q = QUIZ[step];

  return (
    <div className="cv-quiz">
      <div className="cv-progress" aria-hidden="true">
        {QUIZ.map((x, i) => <span key={x.key} className={i <= step || done ? 'on' : ''} />)}
      </div>

      {!done && (
        <>
          <div className="cv-quiz-step">Question {step + 1} of {QUIZ.length}</div>
          <h3>{q.question}</h3>
          <div className="cv-options">
            {q.options.map(([value, label]) => (
              <button key={value} className="cv-option" aria-pressed={answers[q.key] === value} onClick={() => pick(q.key, value)}>{label}</button>
            ))}
          </div>
          <div className="cv-quiz-nav">
            <button className="cv-link-btn" onClick={() => setStep((s) => Math.max(0, s - 1))} disabled={step === 0} style={{ visibility: step === 0 ? 'hidden' : 'visible' }}>← Back</button>
            {answers[q.key] && <button className="cv-link-btn" onClick={() => setStep((s) => s + 1)}>Keep "{q.options.find(([v]) => v === answers[q.key])[1]}" →</button>}
          </div>
        </>
      )}

      {done && reco && (
        <div>
          <span className="cv-result-label">Our recommendation</span>
          <div className="cv-result-name">{reco.provider.name}</div>
          <div className="cv-result-price">{reco.provider.price}{reco.provider.priceNote ? ` · ${reco.provider.priceNote}` : ''} · list price, confirm on their site</div>
          <p className="cv-result-why">{reco.why}</p>
          <div className="cv-result-lines">
            <p><b>Runner-up:</b> {reco.alt}</p>
            <p><b>You can skip:</b> {reco.skip}</p>
          </div>
          <div className="cv-actions">
            <a className="cv-btn cv-btn--accent" href={reco.provider.url} target="_blank" rel="noopener noreferrer sponsored">Go to {reco.provider.name} →</a>
            <button className="cv-link-btn" onClick={() => setStep(QUIZ.length - 1)}>← Change an answer</button>
            <button className="cv-link-btn" onClick={reset}>Start over</button>
          </div>
        </div>
      )}
    </div>
  );
}
